var map = {
	"./kudos-1.svg": 1638,
	"./kudos-2.svg": 4626,
	"./kudos-3.svg": 7176,
	"./kudos-4.svg": 3447,
	"./kudos-5.svg": 1047,
	"./kudos-6.svg": 7418,
	"./kudos-7.svg": 9710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6149;